import React from 'react';

export const Title = ({ record, name }) => {
	// console.log('Title got props', record, name);
	if (record && record.id) {
		return (
			<h1>
				{name}: {record.name}
			</h1>
		);
	} else {
		return <h1>{name}</h1>;
	}
};
